import { $workspace } from "./states";
import { fetchWorkspace } from "./effects";
import '../pages/WorkspaceBilling/store/init';
import '../pages/WorkspaceBilling/modals/CreateSubscriptionModal/store/init';
import '../pages/WorkspaceMembers/store/init';

// Fetch workspace
$workspace.on(fetchWorkspace.doneData, (_, data) => data);
